// Limited Agent training view: Training stays open, but nothing about Resi shows (Kelly, Nov 2026).
// Plain data, no imports: used by the Training pages and copied into the AI connection's training data
// by scripts/build-mcp-training.mjs (functions/mcp/training.js applies the same rules).
export const LIMITED_HIDDEN_MODULES = ['howToUseResi', 'resiSetup', 'teamLeadCert'];
export const LIMITED_HIDDEN_ROUTES = ['/training/how-to-use-resi', '/training/resi-setup', '/training/team-lead-certification'];
// Whole steps that are about Resi itself.
export const LIMITED_HIDDEN_STEPS = [
  'boldtrail-api-token', 'resi-home-screen', 'verify-sending-email', 'niche-news', 'connect-your-ai',
  'resi-google-calendar-setup', 'open-house-post-and-claim',
];
// Any other line that mentions Resi is dropped from the step text.
const RESI = /\bResi\b/i;
export const mentionsResi = (t) => RESI.test(String(t || ''));
export const stripResiText = (text) => String(text || '').split('\n').filter((l) => !mentionsResi(l)).join('\n').trim();

export function limitedStep(step) {
  if (!step || LIMITED_HIDDEN_STEPS.includes(step.id) || mentionsResi(step.title)) return null;
  const body = Array.isArray(step.body)
    ? step.body.map((b) => (typeof b === 'string' ? stripResiText(b) : b)).filter((b) => b !== '')
    : typeof step.body === 'string' ? stripResiText(step.body) : step.body;
  const empty = Array.isArray(body) ? body.length === 0 : !body;
  const hadBody = Array.isArray(step.body) ? step.body.length > 0 : !!step.body;
  if (hadBody && empty && !step.Component) return null;
  const tipBox = step.tipBox ? { ...step.tipBox, items: (step.tipBox.items || []).filter((t) => !mentionsResi(t)) } : step.tipBox;
  return { ...step, body, tipBox };
}

// The module as a Limited Agent sees it, or null when the whole module is hidden.
export function limitedModule(mod) {
  if (!mod || LIMITED_HIDDEN_MODULES.includes(mod.id) || mentionsResi(mod.title)) return null;
  const sections = (mod.sections || []).filter(Boolean)
    .map((s) => ({ ...s, steps: (s.steps || []).filter(Boolean).map(limitedStep).filter(Boolean) }))
    .filter((s) => s.steps.length && !mentionsResi(s.title));
  return sections.length ? { ...mod, intro: mentionsResi(mod.intro) ? '' : mod.intro, sections } : null;
}

// Written lessons (writtenTrainings.js) with Resi lines removed.
export function limitedWritten(w) {
  if (!w) return w;
  const keep = (t) => typeof t !== 'string' || !mentionsResi(t);
  return { ...w, intro: mentionsResi(w.intro) ? '' : w.intro, steps: (w.steps || []).filter(keep), tips: (w.tips || []).filter(keep) };
}
